import React from "react";
import { UnsubscribeThanks } from "~/organisms/UnsubscribeThanks";

const UnsubscribeLeadsThanksPage: React.FC = () => <UnsubscribeThanks />;

export default UnsubscribeLeadsThanksPage;
